// extracted by mini-css-extract-plugin
export var hero = "BlogLayout__hero-DX0Ie";